import * as React from "react";
const SvgFiRrPool8Ball = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pool-8-ball_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m7 9c0 3.859-3.14 7-7 7s-7-3.141-7-7c0-3.618 2.76-6.604 6.285-6.964.237-.017.474-.036.715-.036s.478.019.715.036C16.24 2.395 19 5.382 19 9m-7 13C6.486 22 2 17.514 2 12a9.9 9.9 0 0 1 1.16-4.662A9 9 0 0 0 3 9c0 4.963 4.038 9 9 9s9-4.037 9-9c0-.568-.059-1.123-.16-1.662A9.9 9.9 0 0 1 22 12c0 5.514-4.486 10-10 10M9 6c0 .72.266 1.373.69 1.891A3.48 3.48 0 0 0 8.5 10.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5a3.48 3.48 0 0 0-1.19-2.609A2.97 2.97 0 0 0 15 6c0-1.654-1.346-3-3-3S9 4.346 9 6m3 6c-.827 0-1.5-.673-1.5-1.5S11.173 9 12 9s1.5.673 1.5 1.5S12.827 12 12 12m1-6a1.001 1.001 0 0 1-2 0 1.001 1.001 0 0 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pool-8-ball_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPool8Ball;
